<template>
  <div>
    <div
      class="card mb-3 bg-card-color !border border-card-border profile-card !shadow-none !rounded-[16px]"
      style="width: 100%"
      v-loading="loading"
      element-loading-text="Loading..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div class="card-header bg-card-color !border-b-[0px] !rounded-[16px]">
        <h3 class="title fw-normal !text-black-950 mb-0">Change Password</h3>
      </div>
      <el-form ref="form" :model="updatePassword" class="log-form" id="logForm">
        <el-row>
          <el-col :span="24">
            <div class="card-body">
              <div class="pt-0 px-3">
                <el-form-item class="mb-10 form-item-type-one">
                  <label
                    class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
                  >
                    Current Password
                  </label>
                  <el-input
                    :type="passwordType"
                    placeholder="Enter Old Password"
                    v-model="updatePassword.current_password"
                    :style="getIsMobile ? 'width:100vw' : ''"
                    autocomplete="off"
                    class="input-field"
                  ></el-input>

                  <el-button
                    type="text"
                    :style="getIsMobile ? 'left: 14rem;' : 'left: 15rem;'"
                    class="password-switch"
                    v-if="passwordType == 'password'"
                    @click="passwordType = 'text'"
                  >
                    Show
                  </el-button>

                  <el-button
                    type="text"
                    :style="getIsMobile ? 'left: 14rem;' : 'left: 15rem;'"
                    class="password-switch"
                    v-if="passwordType != 'password'"
                    @click="passwordType = 'password'"
                  >
                    Hide
                  </el-button>

                  <p
                    class="error"
                    v-if="getUpdatePasswordErrors && getUpdatePasswordErrors.current_password"
                  >
                    {{ getUpdatePasswordErrors.current_password }}
                  </p>
                </el-form-item>
                <el-form-item class="mb-1 form-item-type-one">
                  <label
                    class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
                  >
                    New Password
                  </label>

                  <el-input
                    :type="passwordTypenew"
                    placeholder="Enter New Password"
                    v-model="updatePassword.new_password"
                    :style="getIsMobile ? 'width:100vw' : ''"
                    autocomplete="off"
                    class="input-field"
                    @input="checkPassword"
                  ></el-input>
                  <el-button
                    type="text"
                    class="password-switch"
                    :style="getIsMobile ? 'left: 14rem;' : 'left: 15rem;'"
                    v-if="passwordTypenew == 'password'"
                    @click="passwordTypenew = 'text'"
                  >
                    Show
                  </el-button>
                  <el-button
                    type="text"
                    class="password-switch"
                    :style="getIsMobile ? 'left: 14rem;' : 'left: 15rem;'"
                    v-if="passwordTypenew != 'password'"
                    @click="passwordTypenew = 'password'"
                  >
                    Hide
                  </el-button>

                  <p
                    class="error"
                    v-if="getUpdatePasswordErrors && getUpdatePasswordErrors.new_password"
                  >
                    {{ getUpdatePasswordErrors.new_password }}
                  </p>
                  <p class="error" v-if="errors && errors.password">
                    {{ errors.password }}
                  </p>
                </el-form-item>

                <el-form-item class="mb-1 form-item-type-one">
                  <label
                    class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
                  >
                    Confirm Password
                  </label>
                  <el-input
                    :type="passwordTypeconfirm"
                    placeholder="Enter Confirm Password"
                    :style="getIsMobile ? 'width:100vw' : ''"
                    @input="checkConfirmPassword"
                    v-model="updatePassword.cpassword"
                    class="input-field"
                  ></el-input>
                  <el-button
                    type="text"
                    class="password-switch"
                    :style="getIsMobile ? 'left: 14rem;' : 'left: 15rem;'"
                    v-if="passwordTypeconfirm == 'password'"
                    @click="passwordTypeconfirm = 'text'"
                  >
                    Show
                  </el-button>
                  <el-button
                    type="text"
                    class="password-switch"
                    :style="getIsMobile ? 'left: 14rem;' : 'left: 15rem;'"
                    v-if="passwordTypeconfirm != 'password'"
                    @click="passwordTypeconfirm = 'password'"
                  >
                    Hide
                  </el-button>

                  <p class="error" v-if="updatePassword.cpassworderror">
                    {{ updatePassword.cpassworderror }}
                  </p>
                </el-form-item>
              </div>
            </div>
          </el-col>
        </el-row>
        <p class="error" v-if="getUpdatePasswordErrors && getUpdatePasswordErrors.critical_error">
          {{ getUpdatePasswordErrors.critical_error }}
        </p>
        <p class="error" v-for="(err, index) in passwordError" :key="index">
          {{ err }}
        </p>
        <div class="card-footer bg-card-color !border-t-[0px] !rounded-[16px]">
          <el-form-item class="mb-0 py-2">
            <el-button
              @click="getOldData"
              class="hover:!border-brand-500 hover:!text-brand-500 bg-transparent !text-black-700 !px-4 !py-2 !rounded-md !text-xs 2xl:!text-sm !h-fit !border !border-black-700 !h-fit"
              plain
            >
              Cancel
            </el-button>
            <el-button
              type="button"
              class="!bg-brand-500 !text-white !px-4 !py-2 !rounded-md !text-xs 2xl:!text-sm !h-fit"
              @click="onSubmit"
            >
              Save Changes
            </el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import MobileRelatedHelper from '@/mixins/MobileRelatedHelper';
  import DocumentsHelper from '@/mixins/CompanyDocumentsHelper';
  export default {
    name: 'UpdatePassword',
    mixins: [MobileRelatedHelper, DocumentsHelper],
    data() {
      return {
        passwordTypenew: 'password',
        passwordType: 'password',
        passwordTypeconfirm: 'password',
        loading: false,
        updatePassword: {
          current_password: '',
          new_password: '',
          cpassword: '',
          cpassworderror: '',
        },
        //written by sekhar
        passwordError: [],
        password_rules: [
          {
            message:
              'Must have one Uppercase(A-Z) letter,one lowercase(a-z) letter ,one number(0-9) and one symbol',
            regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,30}$/,
          },
        ],
        errors: {},
      };
    },
    computed: {
      ...mapGetters('auth', ['getUpdatePasswordStatus', 'getUpdatePasswordErrors']),
      ...mapGetters('navigationOpen', ['getIsMobile']),
    },
    mounted() {
      this.getCompanyInformation();
      this.$store.commit('auth/setUpdatePasswordErrors', null, { root: true });
    },
    methods: {
      checkPassword() {
        this.errors.password = '';
        this.passwordError = [];
        if (this.updatePassword.new_password) {
          if (
            this.updatePassword.current_password &&
            this.updatePassword.new_password == this.updatePassword.current_password
          ) {
            this.$message.error('Current password and new password should not be same..!');
            this.updatePassword.new_password = '';
          }
          this.password_rules.forEach((rule) => {
            if (!rule.regex.test(this.updatePassword.new_password)) {
              this.passwordError.push(rule.message);
            }
          });
          if (this.updatePassword.new_password.length && this.updatePassword.cpassword.length) {
            // this.checkConfirmPassword();
            if (this.updatePassword.new_password != this.updatePassword.cpassword) {
              this.passwordError.push('Password miss match');
            }
          }
        } else {
          {
            this.errors.password = 'Password is required';
          }
        }
      },
      checkConfirmPassword() {
        this.passwordError = [];
        // if (this.passwordError.length && this.signup.cPassword.length) {
        if (this.updatePassword.new_password != this.updatePassword.cpassword) {
          this.passwordError.push('Password miss match');
        } else {
          this.passwordError = [];
        }
      },
      //written by sekhar
      // checkPassword() {
      //   this.passwordError = [];
      //   this.password_rules.forEach((rule) => {
      //     if (!rule.regex.test(this.updatePassword.new_password)) {
      //       this.passwordError.push(rule.message);
      //     }
      //   });
      // },

      // async onChangePassword(value) {
      //   this.cpassword = value;
      //   if (
      //     this.updatePassword.current_password == this.updatePassword.new_password
      //   ) {
      //     if (this.updatePassword.new_password != this.updatePassword.cpassword) {
      //       this.updatePassword.cpassworderror =
      //         "New Password and confirm password does not match";
      //     } else {
      //       this.updatePassword.cpassworderror = "New password must be different";
      //     }
      //   } else {
      //     this.updatePassword.cpassworderror = "";
      //   }
      // },
      async onSubmit() {
        try {
          this.errors = {};
          this.checkPassword();
          if (
            !this.updatePassword.cpassword.length &&
            this.updatePassword.new_password != this.updatePassword.cpassword
          ) {
            this.passwordError.push('Password miss match');
          }
          if ((this.errors && this.errors.password) || this.passwordError.length) {
            return false;
          } else {
            this.loading = true;
            if (this.updatePassword.cpassword.length) {
              await this.$store.dispatch('auth/updateUserPassword', this.updatePassword);
            }
            if (this.getUpdatePasswordStatus) {
              this.$notify.success({
                title: 'Success',
                message: 'User password updated successfully',
              });
              this.resetStore();
              this.$router.push({ path: '/signin' });
            } else if (
              this.updatePassword.new_password.length &&
              !this.updatePassword.cpassword.length
            ) {
              this.updatePassword.cpassworderror = 'Confirm Your Password';
              //  updatePassword.current_password
            } else {
              this.$notify.error({
                title: 'Error',
                message: 'Error in updating User password',
              });
            }
            this.loading = false;
          }
        } catch (err) {
          console.log('onSubmit', err);
        }
      },
      getOldData() {
        this.updatePassword.current_password = '';
        this.updatePassword.new_password = '';
        this.updatePassword.cpassword = '';
        // this.$router.push({ path: "/" });
      },
      resetStore() {
        this.$store.commit('auth/resetAuthData', null, { root: true });
        this.$store.commit('configurableDocuments/resetConfigurableDocuments', null, {
          root: true,
        });
        this.$store.commit('employeeData/reset', null, { root: true });
        this.$store.commit('employeeDocuments/reset', null, { root: true });
        // this.$store.commit("employeeDocumentAuthorizedUsers/reset");
      },
    },
  };
</script>
<style lang="scss" scoped>
  .log-form {
    .el-input__inner {
      &:hover,
      &:focus {
        border-color: var(--brand-500);
        background-color: #ffffff;
      }
    }
    .password-switch {
      position: absolute;
      margin-left: 15px !important;
      color: var(--brand-500);
    }
  }
  .error {
    color: red;
  }

  .profile-card {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    transform: scale(1);
  }
</style>
<style scoped>
  .el-button.is-plain:hover {
    background: var(--primary-contrast-color);
    border-color: var(--brand-500);
    color: var(--brand-500);
  }
  @media (max-width: 767px) {
    ::v-deep.form-item-type-one div .input-field input {
      width: 65% !important;
    }
  }
</style>
